$(document).ready(function () {
    // モーダル処理
    const $listItems = $('.recommendation_list li, .medicine_list li');
    const $modals = $('.modals .modal');
    const $modalOverlay = $('.modal-overlay');
    const $closeModalButtons = $('.close-modal');
    let scrollTop = 0;
    $listItems.on('click', function () {
        scrollTop = $(window).scrollTop();
        $('body').css({
            position: 'fixed',
            top: -scrollTop + 'px',
            width: '100%',
        });
        const modalId = $(this).data('modal-id');
        $modalOverlay.fadeIn();
        $(`#${modalId}`).fadeIn();
    });
    $closeModalButtons.add($modalOverlay).on('click', function () {
        $('body').css({
            position: '',
            top: '',
            width: '',
        });
        $(window).scrollTop(scrollTop);
        $modalOverlay.fadeOut();
        $modals.fadeOut();
    });
});